import { blast as viemBlast } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const blast = {
  displayName: 'Blast',
  runtime: 'evm',
  viemChain: viemBlast,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 16,

  decoration: {
    color: '#FCFC03',
    contrastColor: getContrastColor('#FCFC03'),
  },
  features: {
    wallet: { supported: true, import: false },
    vault: {
      supported: true,
      ccqRecovery: true,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'blast-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://blastscan.io',
        token: 'https://blastscan.io/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    lifi: { chainKey: 'BLS' },
    stargate: { chainKey: 'blast' },
    relay: {},
    across: { chainKey: 'blast' },
    okx: { chainKey: '81457' },
  }),
  services: defaultServices({
    codex: {
      networkId: 81457,
      nativeLiquidityAddress: '0x4300000000000000000000000000000000000004',
    },
    defiLlama: { chainKeys: ['blast'] },
    zerion: { chainKey: 'blast' },
    coingecko: {
      networkId: 'blast',
      platformId: 'blast',
    },
    coingeckoDex: {
      networkId: 'blast',
    },
    qnStreams: {
      networkKey: 'blast-mainnet',
    },
    pimlico: { chainSlug: 'blast' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
